var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logout_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logout_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 8.6H5.6V7.4h7.7l-.95-.95.85-.85L15.6 8l-2.4 2.4-.85-.85.95-.95ZM10 6.2V3.6H3.6v8.8H10V9.8h1.2v2.6c0 .33-.118.612-.353.848A1.156 1.156 0 0 1 10 13.6H3.6c-.33 0-.613-.117-.848-.352A1.156 1.156 0 0 1 2.4 12.4V3.6c0-.33.117-.612.352-.847S3.27 2.4 3.6 2.4H10c.33 0 .612.118.847.353s.353.517.353.847v2.6H10Z",
    fill: "#404040"
  }))));
};
export default SvgLogout;